import { Navigate } from 'react-router';

import { useTokenStore, useUserInfoStore } from '~/store';

/**
 * AuthRoute 컴포넌트 props type 정의
 * @category AuthRoute
 */
export type TypeAuthRouteProps = {
  /** 라우팅 시 표시할 컴포넌트 */
  component: React.ReactNode;
};

/** 액세스 토큰이 존재하지 않으면 메인 페이지로 이동시키는 라우팅 컴포넌트 */
const AuthRoute = ({ component: Component }: TypeAuthRouteProps): React.JSX.Element => {
  const accessToken = useTokenStore((state) => state.accessToken);
  const laborAccountId = useUserInfoStore((state) => state.laborAccountId);

  return accessToken && laborAccountId !== -1 ? <>{Component}</> : <Navigate to="/login" replace />;
};

export default AuthRoute;
